import { render, staticRenderFns } from "./nuevoArticulo.vue?vue&type=template&id=7bca88c0"
import script from "./nuevoArticulo.vue?vue&type=script&lang=js"
export * from "./nuevoArticulo.vue?vue&type=script&lang=js"
import style0 from "./nuevoArticulo.vue?vue&type=style&index=0&id=7bca88c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports